import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function EditBroker({
  open,
  onClose,
  user,
  brokerlist = [],
  fetchUsers,
}) {
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // 🔹 Auto select user's current broker when modal opens
  useEffect(() => {
    if (open && user?.broker_id && brokerlist.length) {
      const current = brokerlist.find((b) => b.id == user.broker_id);
      setSelectedBroker(current || null);
    } else if (open) {
      setSelectedBroker(null);
    }
  }, [open, user, brokerlist]);

  const handleSave = useCallback(async () => {
    if (isLoading) return;

    if (!selectedBroker) {
      toast.error("Please select a broker");
      return;
    }

    setIsLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id: user.id,
      broker_id: selectedBroker.id,
    };

    try {
      const response = await backend.update_broker(payload);

      if (response.error === "False") {
        toast.success("Broker updated successfully!");
        fetchUsers?.();
        onClose?.();
      } else {
        toast.error(response.message || "Failed to update broker");
      }
    } catch (err) {
      toast.error("Network error! Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, [user, onClose, fetchUsers, selectedBroker, isLoading]);

  // 🔹 ESC to close modal
  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[99999] backdrop-blur-sm">
      <div className="bg-[var(--background)] rounded-xl shadow-xl border-2 border-[var(--hover)] w-[90%] max-w-md p-6 animate-fadeIn">

        {/* Title */}
        <h2 className="text-lg font-semibold text-[var(--text)] mb-4">
          🧑‍💼 Edit Broker
        </h2>

        {/* Broker Dropdown */}
        <label className="text-[var(--text)] text-sm font-medium">
          Select Broker
        </label>

        <select
          className="w-full border bg-[var(--background)] text-[var(--text)] border-[var(--hover)] rounded-lg px-3 py-2 mt-1 text-sm"
          value={selectedBroker?.id || ""}
          onChange={(e) => {
            const b = brokerlist.find((x) => x.id == e.target.value);
            setSelectedBroker(b || null);
          }}
        >
          <option value="">-- SELECT BROKER --</option>
          {brokerlist.map((b) => (
            <option key={b.id} value={b.id}>
              {b.username} — {b.name}
            </option>
          ))}
        </select>

        {/* Buttons */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 bg-[var(--sell)] rounded-lg text-sm font-semibold text-white disabled:opacity-50"
          >
            Cancel
          </button>

          <button
            onClick={handleSave}
            disabled={isLoading}
            className="px-5 py-2 bg-[var(--primary)] rounded-lg text-sm font-semibold text-white disabled:opacity-50"
          >
            {isLoading ? "Saving..." : "Save"}
          </button>
        </div>

      </div>
    </div>
  );
}
